export function stickyNavigation() {
  const nav = document.getElementById('vip-sticky');
  const wrapper = document.getElementById('vip-sticky-wrapper');
  const trigger = document.getElementById('vip-nav');

  if (!nav || !wrapper || !trigger) return;

  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (isMobile) return;

  const navHeight = nav.offsetHeight;

  window.addEventListener('scroll', () => {
    const endTrigger = document.getElementById('more');
    const endTop = endTrigger?.getBoundingClientRect().top ?? Infinity;

    const triggerTop = trigger.getBoundingClientRect().top;

    if (triggerTop <= 100 && endTop > navHeight) {
      if (!nav.classList.contains('is-fixed')) {
        nav.classList.add('is-fixed-animating');
        setTimeout(() => {
          nav.classList.add('is-fixed');
          nav.classList.remove('is-fixed-animating');
        }, 0);
      }
      wrapper.style.height = `${navHeight}px`;
    } else {
      nav.classList.remove('is-fixed');
      nav.classList.remove('is-fixed-animating');
      wrapper.style.height = '';
    }
  });
}


document.addEventListener('DOMContentLoaded', stickyNavigation);

